/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import styled from 'styled-components';

export const InputContainerFileStyled = styled.div`
    display: flex;
    flex-direction: column;
`;
export const InputWrapperFileStyled = styled.div`
    display: flex;
    align-items: center;
    margin-top: 24px;
`;

export const InputFileItemContainerStyled = styled.div`
    margin-top: 16px;
    max-width: 600px;
`;

export const InputFileLabelStyled = styled.label`
    cursor: pointer;
    display: flex;
    padding: 0 24px;
    & > :not(:last-child) {
        margin-right: 16px;
    }
    &:hover {
        opacity: 0.8;
    }
`;

export const InputFileStyled = styled.input`
    width: 0;
    height: 0;
    position: relative;
    opacity: 0;
    visibility: hidden;
    z-index: -1;
`;
